angular.module('webtrader').component('oneTouch', {
  bindings: {
    classes: '=',
  },
  templateUrl: (Account) => {
    if(Account.info.group.is_options)
      return BASE_URL+'templates/component.oneTouchOptions.html'
    return BASE_URL+'templates/component.oneTouch.html'
  },
  controller: function (Account, Quotes) {
    if (!Account.info.group.is_options)
      this.selectedGroup = 'FOREX MAJORS'

    this.quotes = Quotes
    this.updateCubics = () => {
      this.cubics = _(this.quotes.objects)
        .filter({tradable: true})
        .filter(this.selectedGroup ? {group: this.selectedGroup} : {})
        .filter((q)=> q.symbol.indexOf((this.search || "").toUpperCase()) !== -1)
        .orderBy('symbol')
        .value()
      this.cubicsIndices = _.times(Math.ceil(this.cubics.length/2))
    }
    this.updateCubics()
  }
})
